import { CRMProFlexLabels } from './crmThirdParty'

export enum DemoModalProFlexVariants {
  PERMISSION_SHARING = 'permissionSharing',
  PERMISSION_SHARING_USE_CASES = 'permissionSharingUseCases'
}

export enum DemoModalProFlexVariants {
  PRO_FLEX_FLOWTEAMS_UPSELL = 'proFlexFlowteamsUpsell',
  PRO_FLEX_FLOWTEAMS_UPSELL_USE_CASE = 'proFlexFlowteamsUpsellUseCase',
  PRO_FLEX_GEOLOCATION = 'proFlexGeolocation'
}

export enum DemoModalEnterpriseVariants {
  ENTERPRISE_FLOWTEAMS_UPSELL = 'enterpriseFlowteamsUpsell'
}

export type DemoModalVariants =
  | CRMProFlexLabels
  | DemoModalProFlexVariants
  | DemoModalEnterpriseVariants
